import getCdnImg from "@workspace/casino_pages/legacyLayer/shared/cdn/getCdnImg";

const getCdnBoostImg = (handle: string, ext = ".svg") =>
  getCdnImg(`casino-boosts/${handle}`, ext);

export default getCdnBoostImg;
